/* istanbul ignore file */

export enum ColumnTypes {
    Column = 'column',
    Group = 'group',
    GroupTitle = 'GroupTitle',
    Section = 'section',
}
